import { render, staticRenderFns } from "./detailedReportBodyOld.vue?vue&type=template&id=4a90842f&scoped=true"
import script from "./detailedReportBodyOld.vue?vue&type=script&lang=js"
export * from "./detailedReportBodyOld.vue?vue&type=script&lang=js"
import style0 from "./detailedReportBodyOld.vue?vue&type=style&index=0&id=4a90842f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a90842f",
  null
  
)

export default component.exports